var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{staticClass:"time-in-force",attrs:{"title":_vm.$t('trade.expire-time')}},[_c('RadioBox',{attrs:{"options":_vm.timeInForceTypes},model:{value:(_vm.timeInForce),callback:function ($$v) {_vm.timeInForce=$$v},expression:"timeInForce"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }